export default __webpack_public_path__ + "static/media/menu5.05a648f9.png";